'use strict';

function getSecondaryNavHeight(header) {
  const nav = header.querySelector('.nav.nav--depth-2');
  if (!nav) return 0;

  const styles = getComputedStyle(nav);
  const rect = nav.getBoundingClientRect();
  if (
    styles.visibility !== 'hidden' &&
    Number.parseFloat(styles.opacity) > 0.1 &&
    rect.height > 8
  ) {
    return Math.ceil(rect.height);
  }

  const fromVar = Number.parseFloat(
    getComputedStyle(document.documentElement).getPropertyValue('--secondary-nav-height'),
  );
  if (Number.isFinite(fromVar) && fromVar > 8) {
    return Math.ceil(fromVar);
  }

  return 47;
}

function getStickyHeaderOffset() {
  const header = document.querySelector('.header');
  if (!header) return 0;

  const headerHeight = Math.ceil(header.getBoundingClientRect().height);
  const revealsSecondaryNav = Boolean(
    header.classList.contains('header--transparent-mode') ||
      document.querySelector('.js-transparent-header'),
  );

  if (!revealsSecondaryNav) return headerHeight;

  return headerHeight + getSecondaryNavHeight(header);
}

function scrollToWithHeaderOffset(element) {
  const offset = getStickyHeaderOffset();
  const top = window.scrollY + element.getBoundingClientRect().top - offset;
  window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
}

function initSs25ScrollChevrons() {
  const buttons = document.querySelectorAll('[data-ss25-scroll-chevron]');

  buttons.forEach((button) => {
    if (button.dataset.jsBound === 'true') return;
    button.dataset.jsBound = 'true';

    button.addEventListener('click', () => {
      const section =
        button.closest('.section-ss25_media-banner') || button.closest('.shopify-section');
      if (!section) return;

      const next = section.nextElementSibling;
      if (next) {
        scrollToWithHeaderOffset(next);
        return;
      }

      window.scrollBy({
        top: window.innerHeight * 0.85 - getStickyHeaderOffset(),
        behavior: 'smooth',
      });
    });
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initSs25ScrollChevrons);
} else {
  initSs25ScrollChevrons();
}
